import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import AuthShell, { Field } from "./AuthShell";
import { api, errMsg } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Forgot your password?" subtitle="Enter your account email and we'll send you a link to choose a new one."
      footer={<>Remembered it? <Link to="/login" className="font-semibold text-[#2F5D4A] hover:underline" data-testid="forgot-back-to-login">Back to log in</Link></>}>
      {sent ? (
        <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="forgot-password-sent">
          <MailCheck className="w-8 h-8 text-[#2E6F8E]" />
          <p className="mt-3 font-semibold text-[#1A2B25]">Check your inbox</p>
          <p className="mt-1 text-sm text-[#4B5A54]">If an account exists for <strong>{email}</strong>, we've sent a password reset link. It expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" autoComplete="email" />
          {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-3 py-2" data-testid="forgot-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center !py-3" data-testid="forgot-submit-button">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
